import React from "react";
import {Tooltip} from "@mantine/core";

export const CarzelleTooltip = React.memo(({children, message, width}) => {
    if (!message) {
        return children;
    }

    return (
        <Tooltip label={message} arrowSize={8} multiline w={width} openDelay={500} withArrow>
            {children}
        </Tooltip>
    )
});